module.exports = __webpack_public_path__ + "img/CCBlueContent.839f7852.jpg";